import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AutenticationEventType } from '../autentication.event.type';
import { Subscription } from 'rxjs/Subscription';
import { TweenMax, Quint, Power2, Sine } from 'gsap';
import { AutenticationService } from '../autentication.service';
import { AuthMessage } from '../models/auth-message';
import { Auth } from '../Auth';
import { EventTypes } from '../../shared/EventTypes';
import { SecurityAnswer } from '../models/security-answer';
import { IBQuestion } from '../models/ib-question';
import { IBQuestionType } from '../models/ib-question-type';

@Component({
	selector: 'app-security-check',
	templateUrl: './security-check.component.html',
	styleUrls: ['./security-check.component.styl'],
	encapsulation: ViewEncapsulation.None,
	providers: [AuthMessage]
})
export class SecurityCheckComponent implements OnInit, OnDestroy {

	public submited: boolean;
	public view = '[data-component="security-check"]';
	public active = false;
	public subscription: Subscription;
	public form: FormGroup;
	public questions: Array<IBQuestion> = [];
	public activeQuestion: IBQuestion;
	public questionIndex = 0;
	public loading: boolean;
	public answerError: boolean;
	public answerErrorMessage: string;
	public done: boolean;
	public canSend = false;
	public message = undefined;
	public answers: SecurityAnswer[] = [];
	public mask: Array<any> = [];

	constructor(private formBuilder: FormBuilder, private authMessage: AuthMessage, private authService: AutenticationService) {
		this.form = formBuilder.group({
			'answer': [null, Validators.required]
		});
	}

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.SECURITY_CHECK, (data: any) => {
			if (Auth.hasSecurityQuestions) {
				this.authService.getSecurityQuestions(Auth.cpf).subscribe(
					response => {
						this.questions = response;

						this.activeQuestion = this.questions[this.questionIndex];
						this.activeQuestion.type = IBQuestionType.TEXT;
						this.activeQuestion.answerSize = 40;

						this.onGetQuestionsSuccess(response, data);
					}, error => this.onGetQuestionsError(error));
			} else {
				this.authService.getPositiveId(Auth.cpf).subscribe(
					response => {

						this.questions = response;

						this.activeQuestion = this.questions[this.questionIndex];

						this.onGetQuestionsSuccess(response, data);
					}, error => this.onGetQuestionsError(error));

			}

		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.SECURITY_CHECK);
	}

	

	show(data) {
		TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to(this.view, .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	setQuestionMask() {
		this.mask = [];

		if (this.activeQuestion.type === IBQuestionType.TEXT) {
			for (let i = 0; i < this.activeQuestion.answerSize; i++) {
				this.mask.push(/./);
			}
		} else if (this.activeQuestion.type === IBQuestionType.NUMBER) {
			for (let i = 0; i < this.activeQuestion.integerAnswer; i++) {
				this.mask.push(/\d/);
			}
		} else if (this.activeQuestion.type === IBQuestionType.DATE) {
			this.mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
		}

	}

	answerChange(event) {

		if (this.form.controls.answer.valid) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}

	}

	sendAnswer() {

		if (this.canSend) {
			this.submited = true;

			if (this.form.valid && !this.loading && !this.done) {
				this.submited = false;
				this.answerError = false;

				// TODO: Arrumar validação, da uns bugs com maxlength

				let answer = this.form.controls.answer.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
				if (this.activeQuestion.type === IBQuestionType.DATE) {
					answer = answer.split('/').reverse().join('-');
				}

				this.answers.push({ uuid: this.activeQuestion.uuid, answer });

				if (this.questionIndex < (this.questions.length - 1)) {

					TweenMax.to(this.view + ' .question-step', .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
						this.questionIndex++;
						this.activeQuestion = this.questions[this.questionIndex];
						this.activeQuestion.type = this.activeQuestion.type ? this.activeQuestion.type : IBQuestionType.TEXT;
						this.activeQuestion.answerSize = this.activeQuestion.answerSize ? this.activeQuestion.answerSize : 40;

						this.setQuestionMask();
						this.form.controls.answer.setValue('');
						this.form.controls.answer.updateValueAndValidity();


						$(this.view + ' .question-step').css('left', '100%');
						TweenMax.to(this.view + ' .question-step', .8, {left: 0, ease: Quint.easeOut, onComplete: () => {
						}});

					}});

				} else {
					this.loading = true;
					this.sendToService();
				}

			}
		}

	}

	sendToService() {
		if (Auth.hasSecurityQuestions) {
			this.authService.validateSecurityQuestions(this.answers, Auth.cpf).subscribe(
				() => this.onValidadeQuestionsSuccess(),
				error => this.onValidadeQuestionsError(error)
			);
		} else {
			this.authService.validatePositiveIdentification(this.answers, Auth.cpf).subscribe(
				() => this.onValidadeQuestionsSuccess(),
				error => this.onValidadeQuestionsError(error)
			);
		}
	}

	private onGetQuestionsSuccess(response, data) {
		this.setQuestionMask();

		if (data.show) {
			this.active = true;

			const interval = setInterval(() => {
				if ($(this.view).length > 0) {
					AppEventDispatcher.dispatch(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE, null);
					this.show(data);
					clearInterval(interval);
				}
			}, 10);
		}
	}

	private onGetQuestionsError(error) {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		AppEventDispatcher.dispatch(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE, { error: true });
		// AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.RESET_LOGIN, null);
	}

	private onValidadeQuestionsSuccess() {
		this.loading = false;
		this.canSend = false;

		this.questionsDone();
	}

	private onValidadeQuestionsError(error) {
		this.loading = false;
		this.canSend = true;

		if (error.error.Mensagem && error.status !== 500) {
			Auth.definePassword = false;
			this.activeQuestion = null;
			this.setQuestionMask();
			this.authMessage.buttonTitle = 'Continuar';
			this.authMessage.delay = .2;
			this.authMessage.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
			this.authMessage.eventData = { show: true };
			this.authMessage.hasButton = true;
			this.authMessage.title = 'Respostas incorretas, refaça as respostas';
			this.authMessage.text = 'Vamos te ajudar a redefini-la, é fácil e rápido. Vamos lá?';
			this.authMessage.withPreload = true;
			this.questionIndex = 0;
			this.form.controls.answer.setValue('');

			// this.hide(false);
			TweenMax.delayedCall(.2, () => {
				TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut });
				TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut });
				TweenMax.to('[data-component="security-check"]', .8, { left: '100%', ease: Sine.easeOut });

				AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, this.authMessage);
			});
		}
	}

	questionsDone() {
		this.done = true;
		this.loading = true;
		// Auth.setSecurityQuestions(this.correctQuestionsAnswer);

		this.authService.getSmsCode(Auth.cpf).subscribe( sms => {
			this.hide();
			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.SMS_VALIDATION, { show: true, sms: sms });
			this.loading = false;
		});

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/security-check/security-check.component.ts